module.exports = __webpack_public_path__ + "static/media/csohid-bontas-1.4e66eb59.jpg";